window.winHeight = window.innerHeight
  ? window.innerHeight
  : document.body && document.body.clientHeight
  ? document.body.clientHeight
  : 0; // 获取屏幕高度
window.winWidth = window.innerWidth
  ? window.innerWidth
  : document.body && document.body.clientWidth
  ? document.body.clientWidth
  : 0; // 获取屏幕高度
window.u = navigator.userAgent;
window.ua = window.navigator.userAgent.toLowerCase();
window.ISIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
export const isWechat = ua.match(/MicroMessenger/i) == "micromessenger";
export const KGB = winHeight / winWidth; //>1.69全面屏

